export const removeElem = (selector) => {
  for (const el of [...document.querySelectorAll(selector)]) {
    el.remove();
  }
};
